import { HttpClient, HttpHeaders } from '@angular/common/http';
import { errorHttpReal, sinInterceptorGlobal } from 'src/app/shared/utils/error-http-real';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BinanceService {
  API_URL = environment.apiGatewayURL;
  API_NEST = environment.apiNest;

  constructor(private http: HttpClient) {}

  getBinanceRates(): Promise<any> {
    const serviceURL = `${this.API_URL}tasasBinance`;
    return firstValueFrom(this.http.get<any>(serviceURL));
  }

  getConversionData(): Promise<any> {
    const serviceURL = `${this.API_URL}conversion-value`;
    return firstValueFrom(this.http.get<any>(serviceURL));
  }

  getConversionValueRecord(currentPage: number, pageSize: number): Promise<any> {
    const serviceURL = `${this.API_URL}conversion-value-record?page=${currentPage}&pageSize=${pageSize}`;
    return firstValueFrom(this.http.get<any>(serviceURL));
  }

  getCurrentRates():any{
    const serviceURL = `${this.API_URL}conversionRate`;
    return firstValueFrom(this.http.get<any>(serviceURL));
  }

  /** `errorReal`: sin el `ErrorInterceptor`, para recibir el 403 real (ver `ParameterService.saveParameter`). */
  updateRates(tasas: any, email: string, fuente: string, opciones: { errorReal?: boolean } = {}): Promise<any>{
    const serviceURL = `${this.API_URL}conversionRate`;
    const body = {
      tasas,
      email, fuente
    }
    const extra = opciones.errorReal ? { headers: sinInterceptorGlobal(new HttpHeaders()) } : {};
    return firstValueFrom(this.http.put<any>(serviceURL, body, extra));
  }

  updateRateCLPUSDT(tasaCLPUSDT: any, email: string): Promise<any>{
    const serviceURL = `${this.API_URL}update-usdt-value`;
    const body = {
      tasaCLPUSDT,
      email
    }
    return firstValueFrom(this.http.post<any>(serviceURL, body));
  }

  /**
   * Convierte CLP a USDT y guarda en wallet Aguacate
   */
  convertClpToUsdt(userId: string, clpAmount: number, usdtRate: number, usdtAmount: number): Promise<any> {
    const serviceURL = `${this.API_NEST}binance-deposits/convert-clp-to-usdt`;
    const body = {
      userId,
      clpAmount,
      usdtRate,
      usdtAmount
    };
    return firstValueFrom(this.http.post<any>(serviceURL, body));
  }

  /**
   * Igual que `convertClpToUsdt`, pero rechaza con el error real
   * (`{ status, message, detalles, transitorio }`, ver
   * `shared/utils/error-http-real.ts`): el 400 «La tasa cambió…» y el 503
   * «no hay tasa» llegan con su status en vez del 401 sintético. Mueve
   * dinero: un 5xx sin respuesta clara queda `transitorio` (incierto).
   */
  async convertClpToUsdtConErrorReal(
    userId: string,
    clpAmount: number,
    usdtRate: number,
    usdtAmount: number,
  ): Promise<any> {
    const serviceURL = `${this.API_NEST}binance-deposits/convert-clp-to-usdt`;
    const body = { userId, clpAmount, usdtRate, usdtAmount };
    try {
      return await firstValueFrom(
        this.http.post<any>(serviceURL, body, { headers: sinInterceptorGlobal(new HttpHeaders()) }),
      );
    } catch (e) {
      throw errorHttpReal(e, 'Ocurrió un error al procesar la conversión', { conEscape: true, mueveDinero: true });
    }
  }
}
